module.exports = __webpack_public_path__ + "static/media/whitesquare2.991cd094.png";